<template>
  <div class="overlay">
    <div class="widget-wizard-widget" :style="{ width: width }">
      <div class="widget-modal-header">
        <button v-if="activeSlide > 0" class="btn-back" @click="onClickBack()">
          <img src="@/assets/icons/back_white.svg">
        </button>
        <h2 class="wizard-title">{{ title }}</h2>
      </div>
      <div class="widget-modal-body">
        {{ content }}
      </div>
      <div class="slider-dot-widget">
        <div class="slider-dot" v-for="(item, index) in slides" :class="{ active: index == activeSlide }"></div>
      </div>
      <div class="widget-modal-footer">
        <div class="left-modal-options row">
          <div class="modal-option">
            <widgetButton @click="onClickNext" class="btn-primary-white">
              Next
            </widgetButton>
          </div>
          <div class="h-spacer"></div>
          <div class="modal-option">
            <widgetButton @click="onClickClose" class="btn-white-transparent">
              Close
            </widgetButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "widget_wizard",
  props: {
    slides: {
      type: Array,
      default: () => [],
    },
    width: {
      type: String,
      default: "400px",
    },
  },
  data() {
    return {
      title: "",
      content: "",
      activeSlide: -1,
    };
  },
  watch: {},
  mounted() {
    let vm = this;
    vm.activeSlide = 0;
    vm.title = vm.slides[vm.activeSlide].title;
    vm.content = vm.slides[vm.activeSlide].content;
  },
  methods: {
    onClickNext() {
      let vm = this;
      vm.activeSlide++;
      if (vm.activeSlide >= vm.slides.length) {
        vm.activeSlide = 0;
      }
      vm.title = vm.slides[vm.activeSlide].title;
      vm.content = vm.slides[vm.activeSlide].content;
    },
    onClickBack() {
      let vm = this;
      vm.activeSlide--;
      if (vm.activeSlide < 0) {
        vm.activeSlide = vm.slides.length - 1;
      }
      vm.title = vm.slides[vm.activeSlide].title;
      vm.content = vm.slides[vm.activeSlide].content;
    },
    onClickClose() {
      let vm = this;
      vm.$emit("close");
    },
  },
};
</script>
<style lang="scss" scoped>
.overlay {
  position: fixed;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  background: rgba($color: #000000, $alpha: 0.5);
  display: block;
  padding-top: 100px;
  overflow-y: auto;
  z-index: 999999999;

  .widget-wizard-widget {
    margin: 0 auto;
    background: #0986AF;
    border-radius: 10px;
    margin-bottom: 10px;
    position: relative;


    .widget-modal-header {
      display: flex;
      align-items: center;
      padding: 10px 20px;
      padding-top: 30px;

      .btn-back {
        margin-right: 10px;

        img {
          width: 7px;
        }
      }

      .wizard-title {
        font-size: 17px !important;
        margin-bottom: 7px;
        margin-top: 0px;
        color: #ffffff;
        font-weight: 300;
      }
    }

    .widget-modal-body {
      padding: 0px 20px;
      margin-bottom: 20px;
      color: #fff;
    }

    .slider-dot-widget {
      display: flex;
      margin-bottom: 20px;
      padding: 0px 20px;

      .slider-dot {
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: #adadad;
        margin-right: 10px;

        &.active {
          background: #fff;
        }
      }
    }

    .widget-modal-footer {
      padding: 0px 20px;
      padding-bottom: 30px;
      display: flex;
      justify-content: space-between;

      .modal-option {}
    }
  }
}
</style>
